module.exports = __webpack_public_path__ + "r-v3/img/logo_gooroomee_blue_016FF2.17f02068.svg";